import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../../Context";
import { Link } from 'react-router-dom';
export const pageUrl = () => "/mysql/numeric-functions/round";

export default function ROUND() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("Mysql - Numeric Functions - ROUND(x, d) | Aspirant's Home");
        path.setPreviousNext({});
    }, [])

    return (
        <>
            <section class='clearfix mb-3'>
                <span className='float-start'>
                    <Link to='/mysql/numeric-functions' onClick={() => path.setPathName('/mysql/numeric-functions')} className='btn btn-primary'> <i class="fa-solid fa-less-than"></i>&nbsp; Back to Numeric Functions </Link>
                </span>
            </section>
            <section className='mt-5 mb-5'>
                <h3>Mysql - ROUND(x, d) Function</h3>
                <div className='mt-4 mb-5'>
                    <p>
                        The <strong>`ROUND()`</strong> function in MySQL is used to round a numeric value to a specified number of decimal places. It follows standard rounding rules: if the fractional part is less than 0.5, it rounds down; if it's 0.5 or greater, it rounds up.
                    </p>
                    <p>
                        Here is a simple example using the <strong>`ROUND()`</strong> function:
                    </p>
                    <div className='codePalateBox mt-2 mb-2'>
                        <div className='codePalate' dangerouslySetInnerHTML={{
                            __html: `
                                <p><span class="color-blue">SELECT</span> ROUND(<span class="color-pink">4.7</span>);</p>
                            `
                        }}></div>
                    </div>
                    <p>
                        This query will return <strong>`5`</strong>, as 4.7 rounds up to 5.
                    </p>
                    <h5>Rounding to Decimal Places</h5>
                    <p>
                        You can also specify the number of decimal places to round to:
                    </p>
                    <div className='codePalateBox mt-2 mb-2'>
                        <div className='codePalate' dangerouslySetInnerHTML={{
                            __html: `
                                <p><span class="color-blue">SELECT</span> ROUND(<span class="color-pink">4.5678</span>, <span class="color-pink">2</span>);</p>
                            `
                        }}></div>
                    </div>
                    <p>
                        This query will return <strong>`4.57`</strong>, rounding 4.5678 to 2 decimal places.
                    </p>
                </div>
                <div className='mt-5 mb-5'>
                    <h5>ROUND(x, d) with MySQL Table</h5>
                    <div className='mt-3 mb-2'>
                        <p>
                            Consider a table <strong>`temperatures`</strong> with columns <strong>`location`</strong> and <strong>`temperature`</strong>.
                        </p>
                        <table className='table' style={{border: '1px dashed #ccc'}}> 
                            <thead>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>id</th>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>location</th>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>temperature</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>1</td>
                                    <td style={{border: '1px dashed #ccc'}}>New York</td>
                                    <td style={{border: '1px dashed #ccc'}}>25.678</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>2</td>
                                    <td style={{border: '1px dashed #ccc'}}>Los Angeles</td>
                                    <td style={{border: '1px dashed #ccc'}}>30.123</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>3</td>
                                    <td style={{border: '1px dashed #ccc'}}>Chicago</td>
                                    <td style={{border: '1px dashed #ccc'}}>20.987</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>4</td>
                                    <td style={{border: '1px dashed #ccc'}}>Miami</td>
                                    <td style={{border: '1px dashed #ccc'}}>35.543</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            If you want to round the <strong>`temperature`</strong> of each location to two decimal places, you can use the ROUND function as follows:
                        </p>
                        <div className='codePalateBox mt-2 mb-2'>
                            <div className='codePalate' dangerouslySetInnerHTML={{
                                __html: `
                                    <p><span class="color-blue">SELECT</span> location, temperature, ROUND(temperature, 2) <span class="color-blue">AS</span> rounded_temperature <span class="color-blue">FROM</span> temperatures;</p>
                                `
                            }}></div>
                        </div>
                        <p>
                            This query will return:
                        </p>
                        <table className='table' style={{border: '1px dashed #ccc'}}> 
                            <thead>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>id</th>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>location</th>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>temperature</th>
                                    <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>rounded_temperature</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>1</td>
                                    <td style={{border: '1px dashed #ccc'}}>New York</td>
                                    <td style={{border: '1px dashed #ccc'}}>25.678</td>
                                    <td style={{border: '1px dashed #ccc'}}>25.68</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>2</td>
                                    <td style={{border: '1px dashed #ccc'}}>Los Angeles</td>
                                    <td style={{border: '1px dashed #ccc'}}>30.123</td>
                                    <td style={{border: '1px dashed #ccc'}}>30.12</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>3</td>
                                    <td style={{border: '1px dashed #ccc'}}>Chicago</td>
                                    <td style={{border: '1px dashed #ccc'}}>20.987</td>
                                    <td style={{border: '1px dashed #ccc'}}>20.99</td>
                                </tr>
                                <tr style={{border: '1px dashed #ccc'}}>
                                    <td style={{border: '1px dashed #ccc'}}>4</td>
                                    <td style={{border: '1px dashed #ccc'}}>Miami</td>
                                    <td style={{border: '1px dashed #ccc'}}>35.543</td>
                                    <td style={{border: '1px dashed #ccc'}}>35.54</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            In this example, the ROUND function is used to round the <strong>`temperature`</strong> column to two decimal places. The <strong>`ROUND(temperature, 2)`</strong> expression returns the rounded value for each row.
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}